import {Injectable} from '@angular/core';
import {AppHttpClient} from '@common/core/http/app-http-client.service';
import {LinkStats} from '../../shared/link/link.service';
import {BackendResponse} from '@common/core/types/backend-response';
import {Biolink, BiolinkAppearance} from './biolink';
import {BiolinkWidget} from './biolink-editor/widgets/biolink-widget';
import {Link} from '../../shared/link/link';
import {BiolinkLink} from './biolink-editor/biolink-link';

export interface BiolinkItemConfig {
    animation?: string;
    leap_until?: string;
    active?: boolean;
}

@Injectable({
    providedIn: 'root',
})
export class BiolinksService {
    static BASE_URI = 'biolink';
    constructor(private http: AppHttpClient) {}

    get(
        id: number,
        params: {with: string[]}
    ): BackendResponse<{biolink: Biolink}> {
        return this.http.get(`${BiolinksService.BASE_URI}/${id}`, params);
    }

    create(params: Partial<Biolink>): BackendResponse<{biolink: Biolink}> {
        return this.http.post(BiolinksService.BASE_URI, params);
    }

    update(id, params: Partial<Biolink>): BackendResponse<{biolink: Biolink}> {
        return this.http.put(`${BiolinksService.BASE_URI}/${id}`, params);
    }

    delete(ids: number[]): BackendResponse<void> {
        return this.http.delete(`${BiolinksService.BASE_URI}/${ids}`);
    }

    detach(groupId: number, contentItem: BiolinkLink | BiolinkWidget) {
        return this.http.post(`${BiolinksService.BASE_URI}/${groupId}/detach`, {
            contentItem,
        });
    }

    changeOrder(id: number, params: {id: number; model_type: string}[]) {
        return this.http.post(
            `${BiolinksService.BASE_URI}/${id}/change-order`,
            {order: params}
        );
    }

    analytics(
        biolinkId: number
    ): BackendResponse<{analytics: LinkStats, biolink: Biolink}> {
        return this.http.get(this.analyticsEndpoint(biolinkId));
    }

    analyticsEndpoint(biolinkId: number): string {
        return `${BiolinksService.BASE_URI}/${biolinkId}/analytics`;
    }

    saveAppearance(id: number, config: BiolinkAppearance) {
        return this.http.post(`${BiolinksService.BASE_URI}/${id}/appearance`, {
            config,
        });
    }

    updateContentItemConfig(
        biolinkId: number,
        contentItem: BiolinkWidget | Link,
        config: BiolinkItemConfig
    ) {
        return this.http.post(
            `${BiolinksService.BASE_URI}/${biolinkId}/update-content-config`,
            {
                item_id: contentItem.id,
                item_model_type: contentItem.model_type,
                ...config,
            }
        );
    }
}
